<script>
import refundDialog from '@/views/order/mixin/dialogRefund';
export default {
  components: {
    'refund-dialog': refundDialog,
  },
  data() {
    return {
      refundObj: {
        selectOrder: null,
        showDialog: false,
      },
    };
  },
  methods: {
    clickRefund(order) {
      this.refundObj.selectOrder = order;
      this.refundObj.showDialog = true;
    },
  },
};
</script>
